export const discountHistoryKeys = {
  all: ['discount-history'] as const,
  lists: () => [...discountHistoryKeys.all, 'list'] as const,
  list: (id: number, page: number, perPage: number) =>
    [...discountHistoryKeys.lists(), { id, page, perPage }] as const,
};
